// profile
import profilePage from '../pages/profile/ProfilePage.vue'
import profilePostsPage from '../pages/profile/ProfilePostsPage.vue'

// single pages
import homePage from '../pages/Home.vue'
import ProjectsList from '../pages/news/ProjectsList.vue'
import projectPage from '../pages/project/ProjectPage.vue'
import loginPage from '../pages/Login.vue'
import notFoundPage from '../pages/NotFound.vue'
import BotPage from '../pages/bot/BotPage.vue'
import Hp from '../pages/Hp.vue'

import { routePropResolver } from './util'
import { DOMAIN_TITLE } from '../.env'

export const routes = [
  {    
    path: '/congrats',
    name: 'congrats',
    component: Hp,
    meta: { title: `${DOMAIN_TITLE} | home` }
  },
  {    
    path: '/',
    name: 'index',
    component: ProjectsList,
    meta: { title: `${DOMAIN_TITLE} | home` }
  },
  {
    path: '/project/:project_id/bot/:id',
    name: 'bot',
    component: BotPage,
    meta: { title: `${DOMAIN_TITLE} | bot` }
  },
  {
    path: '/projects',
    name: 'projects',
    component: ProjectsList,
    meta: { title: `${DOMAIN_TITLE} | news` },
    props: routePropResolver
  },
  {
    path: '/profile',
    component: profilePage,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | profile` },
    children: [
      {
        path: '',
        name: 'profile',
        component: profilePostsPage
      }
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: loginPage,
    meta: { title: `${DOMAIN_TITLE} | login` }
  },
  {
    path: '/project/:id',
    name: 'project',
    component: projectPage,
    meta: { title: `${DOMAIN_TITLE} | login` }
  },
  {
    path: '*',
    component: notFoundPage,
    meta: { title: `${DOMAIN_TITLE} | not found` }
  }
]
